import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "navbar"
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { Expand } from '@element-plus/icons-vue';
export default {
  __name: 'Navbar',
  setup(__props) {
    const permitLogin = ref(true);
    const menuRef = ref(null);
    // const dialogVisible = ref(false)
    const route = useRoute();

    // 登录跳转：
    const handleClick = () => {
      // console.log('OK')
      window.location = 'https://www.fomyom.com/admin/#/login';
    };
    // const exit =()=>{
    //   // dialogVisible.value = false;
    //   //  window.location = 'http://192.168.5.9:8080'
    // }
    onMounted(() => {
      var system = {};
      var p = navigator.platform;
      var u = navigator.userAgent;
      system.win = p.indexOf('Win') == 0;
      system.mac = p.indexOf('Mac') == 0;
      system.x11 = p == 'X11' || p.indexOf('Linux') == 0;
      if (system.win || system.mac || system.xll) {
        permitLogin.value = true;
      } else {
        permitLogin.value = false;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": _unref(route).fullPath,
        class: "el-menu",
        mode: "horizontal",
        router: true,
        "ellipsis-icon": _unref(Expand)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("首页", -1)]))]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/news"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("公司动态", -1)]))]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/product"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("产品服务", -1)]))]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/cooperative"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("商业合作", -1)]))]),
          _: 1
        }), permitLogin.value ? (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 0,
          index: "",
          onClick: handleClick
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("登录", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["default-active", "ellipsis-icon"])]);
    };
  }
};